import angular from 'angular'
import './deposit_match.service'
import './edit/edit.controller'

angular
  .module('admin.deposit_match', ['admin.deposit_match.service', 'admin.deposit_match.edit'])
  .controller('DepositMatchCtrl', DepositMatchCtrl)

/** @ngInject */
function DepositMatchCtrl($state, $timeout, DepositMatchService) {
  var vm = this
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'ts-desc'
  vm.sortReverse = false

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()
  load(1)

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    DepositMatchService.list(vm.oldPage, 25, vm.sortType).then(function (result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      vm.sortType = oldSortType
      vm.items = items
    })
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    $state.go('admin.deposit_match.edit', { id: 0 })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DepositMatchService.remove(item.id).then(
            function () {
              $state.reload()
            },
            function () {
              $timeout(function () {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.back = function () {
    load(1)
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      load(vm.pagination.current)
    }
  }
}
